const STATUS = {
  init: 'init',
  loading: 'loading',
  resolved: 'resolved',
  rejected: 'rejected',
};

const states = {
  [STATUS.init]: () => ({
    loading: false,
    data: null,
    error: null,
  }),
  [STATUS.loading]: () => ({
    loading: true,
    error: null,
    data: null,
  }),
  [STATUS.resolved]: data => ({
    loading: false,
    error: null,
    data,
  }),
  [STATUS.rejected]: error => ({
    loading: false,
    error,
    data: null,
  }),
};

export { STATUS, states };
